module.exports = __webpack_public_path__ + "img/syimg4.08d1fbc2.png";